export const MessageCornerIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={19} height={20} fill="none" {...props}>
    <path
      fill="#fff"
      d="M18.576 14.794a.5.5 0 0 1-.264.823L1.216 19.294c-.522.112-.858-.602-.459-.958 4.321-3.854 5.556-7.972 4.754-16.783-.044-.484.556-.755.88-.392l12.186 13.633Z"
    />
  </svg>
);
